import { useIsMobile } from '../../../utils/getIsMobile';
import { useTranslation } from '../../../utils/useTranslation';
import { FormControl } from '../../input/FormControl';
import { Radio } from '../../input/Radio';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Button, Wrapper } from './styles';
import { BusinessRegistrationTypeProps } from './types';

export const BusinessRegistrationType = ({
    title,
    description,
    onClick,
    ...other
}: BusinessRegistrationTypeProps) => {
    const t = useTranslation();
    const isMobile = useIsMobile();
    const buttonText = t('Изменить');

    return (
        <Wrapper {...other}>
            <FormControl width="24px">
                <Radio checked />
            </FormControl>
            <Flex>
                <Typography variant="body" weight="bold" mt={0.25}>
                    {title}
                </Typography>
                <Typography variant="body2" mb={isMobile ? 0 : 0.5}>
                    {description}
                </Typography>
                {isMobile ? (
                    <Button onClick={onClick} mt={2}>
                        {buttonText}
                    </Button>
                ) : null}
            </Flex>
            {isMobile ? null : (
                <Button onClick={onClick} ml="auto">
                    {buttonText}
                </Button>
            )}
        </Wrapper>
    );
};
